import {Col, ColType, Crud, optionOf} from "../../comp/crud";
import {ApiClient} from "../../api/ApiClient";

let apiClient = ApiClient.getDefault();
let cols: Col[] = [
    {
        name: "ID",
        key: "id",
        type: ColType.STRING
    },
    {
        name: "KEY",
        key: "key",
        hideInEdit: true,
        type: ColType.STRING
    },
    {
        name: "名称",
        key: "name",
        type: ColType.STRING
    },
    {
        name: "角色",
        key: "roles",
        type: ColType.MULTI_SELECT,
        getOptions: () => apiClient.getAllRoles().then(r => r.data.records.map(g => optionOf(g.code, g.name))),
        render: (value) => {return value.join(", ")}
    },
]
export default function RoleGroup(){
    return <Crud
        canUpdate={true}
        canCreate={true}
        name="角色组"
        entityKey="roleGroup"
        pageSize={50}
        cols={cols}
    />
}